import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch, useAppSelector} from "../../../../../../../../app/hooks";
import {ValidatedTextAreaField} from "../../../../../../../elements/validator/component/ValidatedTextAreaField";
import {NotEmptyStringValidator} from "../../../../../../../elements/validator/Validator";
import {
    selectFooterMessage,
    selectShowFooterMessage,
    updateLocalizedField,
    updateSettings
} from "../../../widgetAppearanceUpdateSlice";

interface FooterMessageViewProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const FooterMessageView: React.FC<FooterMessageViewProps> = ({
                                                                        getMessageWrapper,
                                                                        updateValidationStatus
                                                                    }) => {
    const dispatch = useAppDispatch();
    const showFooterMessage = useAppSelector(selectShowFooterMessage);

    return <AppearanceTabSettingsContainer
        title="Footer Message"
        withSwitch={true}
        switchValue={showFooterMessage}
        onSwitchChange={(v) => dispatch(updateSettings({
            showFooterMessage: v
        }))}
    >
        {showFooterMessage && <div className={styles.fieldsLine}>
            <ValidatedTextAreaField
                onChange={(v) => dispatch(updateLocalizedField({
                    field: "footerMessage",
                    value: v
                }))}
                updateValidationStatus={updateValidationStatus}
                fieldName="footerMessage"
                selector={selectFooterMessage}
                validator={NotEmptyStringValidator}
                label="Footer Message"
                maxLength={1200}
                placeholder="Paste here your preferable footer message"
                getMessage={getMessageWrapper}
                required={false}
            />
        </div>
        }
    </AppearanceTabSettingsContainer>
}
